import { c as _c } from "react/compiler-runtime";
import { InfiniteData, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/actions/api";
import { QueryKeys } from "@/constants/queryKeys";
import { useToast } from "@/hooks/use-toast";
import { useIsMobile } from "@/hooks/use-mobile";
import uuidSlugUtil from "@/utils/uuidSlugUtil";
import { Query } from "@/types/queryTpes";
import { RealEstateType } from "@/types/real-estate";
import useRealEstateGroups from "@/hooks/QueryHooks/useRealEstateGroups";
import { queryKeysFavoritesGroups } from "../query-options";
export const useAddFavoritesGroupMutation = (groupName, realEstateId, onSuccessCallback) => {
  const $ = _c(16);
  const queryClient = useQueryClient();
  const {
    toast
  } = useToast();
  const {
    refetch: refetchRealEstateGroups
  } = useRealEstateGroups(realEstateId);
  const isMobile = useIsMobile();
  let t0;
  if ($[0] !== queryClient) {
    t0 = async variables => {
      const {
        realEstateId: realEstateId_0
      } = variables;
      const queryKey = uuidSlugUtil(undefined, realEstateId_0);
      const previousListQueries = queryClient.getQueriesData({
        queryKey: [QueryKeys.REAL_ESTATE]
      });
      const previousDetailData = queryClient.getQueryData([QueryKeys.REAL_ESTATE_DETAIL, queryKey]);
      queryClient.setQueriesData({
        queryKey: [QueryKeys.REAL_ESTATE]
      }, oldData => {
        if (!oldData) {
          return oldData;
        }
        const updatedPages = oldData.pages.map(page => ({
          ...page,
          data: page.data.map(item => {
            if (item.realEstate.id === realEstateId_0) {
              return {
                ...item,
                isFavorite: true,
                analytics: {
                  ...item.analytics,
                  favoritesCount: (item.analytics?.favoritesCount ?? 0) + 1
                }
              };
            }
            return item;
          })
        }));
        return {
          ...oldData,
          pages: updatedPages
        };
      });
      queryClient.setQueryData([QueryKeys.REAL_ESTATE_DETAIL, queryKey], _temp);
      return {
        previousListQueries,
        previousDetailData
      };
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== queryClient || $[3] !== toast) {
    t1 = (err, variables_0, context) => {
      const queryKey_0 = uuidSlugUtil(undefined, variables_0.realEstateId);
      if (context?.previousListQueries) {
        for (const [key, data] of context.previousListQueries) {
          queryClient.setQueryData(key, data);
        }
      }
      if (context?.previousDetailData) {
        queryClient.setQueryData([QueryKeys.REAL_ESTATE_DETAIL, queryKey_0], context.previousDetailData);
      }
      toast({
        variant: "destructive",
        title: "Erro ao atualizar im\xF3vel no grupo",
        description: "Ocorreu um erro ao adicionar imovel no grupo."
      });
    };
    $[2] = queryClient;
    $[3] = toast;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== groupName || $[6] !== isMobile || $[7] !== onSuccessCallback || $[8] !== queryClient || $[9] !== refetchRealEstateGroups || $[10] !== toast) {
    t2 = () => {
      onSuccessCallback?.();
      refetchRealEstateGroups();
      queryClient.invalidateQueries({
        queryKey: queryKeysFavoritesGroups.all
      });
      if (!isMobile) {
        toast({
          variant: "success",
          description: `O imóvel adicionado ao grupo "${groupName}".`
        });
      }
    };
    $[5] = groupName;
    $[6] = isMobile;
    $[7] = onSuccessCallback;
    $[8] = queryClient;
    $[9] = refetchRealEstateGroups;
    $[10] = toast;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t0 || $[13] !== t1 || $[14] !== t2) {
    t3 = {
      mutationFn: api.favoriteGroups.addToFavoritesGroup,
      onMutate: t0,
      onError: t1,
      onSuccess: t2
    };
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return useMutation(t3);
};
function _temp(old) {
  return old ? {
    ...old,
    data: {
      ...old.data,
      isFavorite: true,
      analytics: {
        ...old.data.analytics,
        favoritesCount: (old.data.analytics?.favoritesCount ?? 0) + 1
      }
    }
  } : old;
}